import React, {useState} from 'react';

import {withRouter, WithRouterProps} from 'react-router';

import {createFormErrorsContext} from 'app/general/forms';
import {GeneralCreateItem} from 'app/general/widgets/GeneralCreateItem';
import {useCreateTeam} from 'app/teams/api';
import {gt} from 'app/utils/i18n';

import type {FormErrorsProps} from 'app/general/forms';
import type {TeamSerializedType} from 'sweet-types';

type RouterProps = WithRouterProps<{
  name?: string;
}>;
type OwnProps = {
  onCreateTeam: (team: TeamSerializedType) => any;
  showCancelButton: boolean;
  small?: boolean;
  isPopover: boolean;
};
type OwnPropsWithRouter = OwnProps & RouterProps;
type Props = OwnPropsWithRouter & FormErrorsProps;

export const CreateTeamForm = createFormErrorsContext(
  withRouter((props: Props) => {
    const {small, location} = props;
    const [isCreating, setIsCreating] = useState(false);
    const [description, setDescription] = useState('');

    const [createTeam] = useCreateTeam();

    const doCreateTeam = (name: string) => {
      setIsCreating(true);
      return createTeam({name, description})
        .unwrap()
        .then(props.onCreateTeam, (err: Error) => {
          props.captureFormErrorsFromRejection(err);
        })
        .finally(() => {
          setIsCreating(false);
        });
    };

    const generalDescription = (
      <span className={props.small === true ? 'small' : ''}>
        <p>
          {gt(
            'A team is a way to control access to your procedures, processes and policies. '
          )}
        </p>
        <p>
          {gt(
            'Any staff added to a team may view or if you choose, %s, the procedures, processes and policies it contains.',
            <i>{gt('edit')}</i>
          )}
        </p>
      </span>
    );

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      setDescription(value);
    };
    return (
      <GeneralCreateItem
        {...props}
        defaultName={location.query.name}
        isCreating={isCreating}
        description={generalDescription}
        namePlaceholder={gt('Team name')}
        createLabel={gt('Create Team')}
        onCreate={doCreateTeam}
      >
        <div className="form-group">
          <input
            type="text"
            className={`form-control ${
              small === true ? 'form-control-sm' : ''
            }`}
            maxLength={512}
            name="description"
            placeholder={gt('Enter a description for this team')}
            onChange={handleInputChange}
            value={description}
          />
        </div>
      </GeneralCreateItem>
    );
  })
);
